import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useUser } from '../contexts/UserContext';
import { useCultivation } from '../contexts/CultivationContext';

const Header = () => {
  const { user, logout, meritPoints } = useUser();
  const { currentLevel } = useCultivation();
  const navigate = useNavigate();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  return (
    <header className="bg-cyber-dark bg-opacity-80 backdrop-blur-md border-b border-cyber-primary shadow-cyber sticky top-0 z-50">
      <div className="container mx-auto px-4 py-4">
        <div className="flex justify-between items-center">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-2">
            <span className="text-3xl font-xianxia text-cyber-primary glowing-text">天道宗</span>
            <span className="hidden md:inline-block text-sm font-cyber text-cyber-secondary">赛博修仙</span>
          </Link>

          {/* 移动端菜单按钮 */}
          <button
            className="md:hidden text-cyber-primary hover:text-cyber-accent transition duration-300"
            onClick={toggleMobileMenu}
          >
            <i className={`fas ${mobileMenuOpen ? 'fa-times' : 'fa-bars'} text-xl`}></i>
          </button>

          {/* 桌面端导航 */}
          <nav className="hidden md:flex items-center space-x-6">
            <Link to="/cultivation" className="text-cyber-light hover:text-cyber-primary transition duration-300">
              修炼系统
            </Link>
            <Link to="/artifact-refining" className="text-cyber-light hover:text-cyber-primary transition duration-300">
              炼器系统
            </Link>
            <Link to="/divination" className="text-cyber-light hover:text-cyber-primary transition duration-300">
              占卜系统
            </Link>
            <Link to="/telomere-testing" className="text-cyber-light hover:text-cyber-primary transition duration-300">
              寿命检测
            </Link>
            <Link to="/virtual-currency" className="text-cyber-light hover:text-cyber-primary transition duration-300">
              功德点
            </Link>
            <Link to="/quest-system" className="text-cyber-light hover:text-cyber-primary transition duration-300">
              任务系统
            </Link>
          </nav>

          {/* 用户菜单 */}
          <div className="hidden md:flex items-center space-x-4">
            {user ? (
              <>
                <div className="text-cyber-light">
                  <span className="text-cyber-secondary mr-2">功德点:</span>
                  <span className="text-cyber-accent">{meritPoints}</span>
                </div>
                <div className="text-cyber-light">
                  <span className="text-cyber-secondary mr-2">境界:</span>
                  <span className="text-cyber-accent">{currentLevel?.name || '筑基期'}</span>
                </div>
                <Link
                  to="/dashboard"
                  className="flex items-center space-x-2 text-cyber-light hover:text-cyber-primary transition duration-300"
                >
                  <i className="fas fa-user-circle"></i>
                  <span>{user.displayName}</span>
                </Link>
                <button
                  onClick={handleLogout}
                  className="cyber-button"
                >
                  退出
                </button>
              </>
            ) : (
              <>
                <Link to="/login" className="cyber-button">
                  登录
                </Link>
                <Link to="/register" className="cyber-button">
                  注册
                </Link>
              </>
            )}
          </div>
        </div>

        {/* 移动端菜单 */}
        {mobileMenuOpen && (
          <div className="md:hidden mt-4 pb-2 cyber-panel p-4">
            <nav className="flex flex-col space-y-3">
              <Link
                to="/cultivation"
                className="text-cyber-light hover:text-cyber-primary transition duration-300"
                onClick={() => setMobileMenuOpen(false)}
              >
                修炼系统
              </Link>
              <Link
                to="/artifact-refining"
                className="text-cyber-light hover:text-cyber-primary transition duration-300"
                onClick={() => setMobileMenuOpen(false)}
              >
                炼器系统
              </Link>
              <Link
                to="/divination"
                className="text-cyber-light hover:text-cyber-primary transition duration-300"
                onClick={() => setMobileMenuOpen(false)}
              >
                占卜系统
              </Link>
              <Link
                to="/telomere-testing"
                className="text-cyber-light hover:text-cyber-primary transition duration-300"
                onClick={() => setMobileMenuOpen(false)}
              >
                寿命检测
              </Link>
              <Link
                to="/virtual-currency"
                className="text-cyber-light hover:text-cyber-primary transition duration-300"
                onClick={() => setMobileMenuOpen(false)}
              >
                功德点
              </Link>
              <Link
                to="/quest-system"
                className="text-cyber-light hover:text-cyber-primary transition duration-300"
                onClick={() => setMobileMenuOpen(false)}
              >
                任务系统
              </Link>
              
              {/* 用户菜单 - 移动版 */}
              <div className="pt-3 border-t border-cyber-primary">
                {user ? (
                  <>
                    <div className="text-cyber-light mb-2">
                      <span className="text-cyber-secondary mr-2">功德点:</span>
                      <span className="text-cyber-accent">{meritPoints}</span>
                    </div>
                    <div className="text-cyber-light mb-2">
                      <span className="text-cyber-secondary mr-2">境界:</span>
                      <span className="text-cyber-accent">{currentLevel?.name || '筑基期'}</span>
                    </div>
                    <Link
                      to="/dashboard"
                      className="block py-2 text-cyber-light hover:text-cyber-primary transition duration-300"
                      onClick={() => setMobileMenuOpen(false)}
                    >
                      <i className="fas fa-user-circle mr-2"></i>
                      <span>{user.displayName}</span>
                    </Link>
                    <button
                      onClick={() => {
                        handleLogout();
                        setMobileMenuOpen(false);
                      }}
                      className="cyber-button w-full mt-2"
                    >
                      退出
                    </button>
                  </>
                ) : (
                  <div className="flex flex-col space-y-2">
                    <Link
                      to="/login"
                      className="cyber-button block text-center"
                      onClick={() => setMobileMenuOpen(false)}
                    >
                      登录
                    </Link>
                    <Link
                      to="/register"
                      className="cyber-button block text-center"
                      onClick={() => setMobileMenuOpen(false)}
                    >
                      注册
                    </Link>
                  </div>
                )}
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
